import { useDispatch, useSelector } from "react-redux"
import Header from "./Header";
import { logout } from "../../modules/auth/userSlice";
import { changeField as changeLanguage } from "../../modules/language/languageSlice";

const HeaderContainer = () => {
    const dispatch = useDispatch();
    // const { user, project } = useSelector(({ user, project }) => ({
    //     user: user.user,
    //     project: project?.project,
    // }));
    const user = useSelector(state => state.user.user);
    const project = useSelector(state => state.project.project);
    const language = useSelector(state => state.language.language);

    const onLogout = () => {
        dispatch(logout());
    }

    const onChangeLanguage = (e) => {
        dispatch(changeLanguage({
            key: 'language',
            value: e.target.value,
        }))
    }

    return (
        <Header user={user} project={project} language={language} onChangeLanguage={onChangeLanguage} onLogout={onLogout} />
    );
};

export default HeaderContainer;